const ATTRIBUTION_STORAGE_KEY = 'wacc_attribution';
const ATTRIBUTION_PROPERTY_MAP = {
  gclid: 'gclid_last_seen',
  fbclid: 'fbclid_last_seen',
  ttclid: 'ttclid_last_seen',
  utm_source: 'utm_source_last_seen',
  utm_medium: 'utm_medium_last_seen',
  utm_campaign: 'utm_campaign_last_seen',
  utm_content: 'utm_content_last_seen',
  utm_term: 'utm_term_last_seen',
  _captured_at: 'attribution_captured_at',
};

function readCookie(name) {
  const prefix = `${name}=`;
  const cookies = document.cookie ? document.cookie.split(';') : [];

  for (const cookieValue of cookies) {
    const cookie = cookieValue.trim();

    if (cookie.indexOf(prefix) === 0) {
      return decodeURIComponent(cookie.slice(prefix.length));
    }
  }

  return null;
}

function readStoredAttribution() {
  let stored = null;

  try {
    stored = window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY);
  } catch (error) {
    stored = null;
  }

  if (!stored) {
    stored = readCookie(ATTRIBUTION_STORAGE_KEY);
  }

  if (!stored) {
    return null;
  }

  try {
    return JSON.parse(stored);
  } catch (error) {
    return null;
  }
}

function buildProfileProperties(signupSource) {
  const properties = {
    signup_source: signupSource,
  };
  const attribution = readStoredAttribution();

  if (!attribution) {
    return properties;
  }

  Object.keys(ATTRIBUTION_PROPERTY_MAP).forEach((key) => {
    if (attribution[key]) {
      properties[ATTRIBUTION_PROPERTY_MAP[key]] = attribution[key];
    }
  });

  return properties;
}

class WaccFooterSignup {
  constructor(form) {
    this.form = form;
    this.feedback = form.parentElement.querySelector('.wacc-footer-signup__feedback');
    this.form.addEventListener('submit', (event) => this.submit(event));
  }

  async submit(event) {
    event.preventDefault();
    const email = this.form.querySelector('input[name="email"]')?.value.trim();
    const publicApiKey = this.form.dataset.klaviyoPublicApiKey;
    const listId = this.form.dataset.klaviyoListId;
    const source = this.form.dataset.signupSource || 'footer';

    if (!email || !this.validEmail(email)) {
      this.setFeedback('Enter a valid email address.', true);
      return;
    }

    if (!publicApiKey || !listId) {
      this.setFeedback('Signup settings are being connected.', true);
      return;
    }

    this.setFeedback('Joining...');

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicApiKey)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2026-04-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      properties: buildProfileProperties(source),
                    },
                  },
                },
                custom_source: source,
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          }),
        },
      );

      if (!response.ok) throw new Error('Klaviyo signup failed');

      this.form.reset();
      this.setFeedback('You are on the list.');
    } catch (error) {
      this.setFeedback('Could not join right now. Please try again.', true);
    }
  }

  validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  setFeedback(message, isError = false) {
    if (!this.feedback) return;
    this.feedback.textContent = message;
    this.feedback.classList.toggle('is-error', isError);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wacc-footer-signup__form').forEach((form) => {
    new WaccFooterSignup(form);
  });
});
